function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import utils from '@/js/utils';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import tasks from '@/js/tasks';
export var crudAreas = {
  data: function data() {
    return {
      isBusy: false,
      busy: false,
      busy2: false,
      isBusyDetail: false,
      processing: false,
      mode: '',
      record: Object,
      record_original: Object,
      overlay_message: '',
      recordSelected: null,
      items: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      dangerMessage: '',
      perPage: 10,
      currentPage: 1
    };
  },
  computed: {
    readonly: function readonly() {
      return this.mode === 'view';
    },
    showMonitoringInput: function showMonitoringInput() {
      return this.mode !== 'create';
    },
    modalTitle: function modalTitle() {
      var mode = this.mode.charAt(0).toUpperCase() + this.mode.slice(1);
      var modalName = this.modalName;
      var aux = "crud." + mode;
      var modename = this.traductor(aux);
      return "".concat(modename, " ").concat(modalName);
    },
    areaName: function areaName() {
      var _this = this;
      return function (record_id) {
        var record = _this.select_profile_areas.filter(function (rec) {
          return rec.record_id === record_id;
        });
        var recordName = '';
        if (record.length) {
          recordName = record[0].area_description;
        }
        return recordName;
      };
    },
    areasActive: function areasActive() {
      return this.select_profile_areas.filter(function (rec) {
        return rec.flag_active;
      });
    },
    profileUserActive: function profileUserActive() {
      return this.select_profile_users.filter(function (rec) {
        return rec.flag_active;
      });
    }
  },
  watch: {
    'record.area_id': function recordArea_id() {
      var area_id = this.record.area_id;
      if (this.select_profile_users) {
        this.profileFiltered = this.select_profile_users.filter(function (rec) {
          return rec.area_id === area_id;
        });
      }
    }
  },
  created: function created() {
    this.getRecords();
  },
  methods: {
    getRecords: function getRecords() {},
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getValuesToUpdate: function getValuesToUpdate(record, record_original) {
      var toSave = Object.keys(record).reduce(function (diff, key) {
        if (record[key] === record_original[key]) return diff;
        return _objectSpread(_objectSpread({}, diff), {}, _defineProperty({}, key, record[key]));
      }, {});
      var keys = Object.keys(toSave);
      var oldValues = {};
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        if (key === 'load_date') continue;
        oldValues[key] = record_original[key];
      }
      toSave.record_id = record_original.record_id;
      return {
        toSave: toSave,
        oldValues: oldValues
      };
    },
    showModal: function showModal(data, mode) {
      if (data) {
        this.recordSelected = data.index;
        this.record = utils.cloneJSON(data.item);
        this.record_original = utils.cloneJSON(data.item);
      } else {
        this.record = {};
      }
      this.mode = mode;
      this.$refs.dialog.onOpen();
      // this.$root.$emit('bv::show::modal', this.modalId, '#btnShow')
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.mode == 'create') {
        var data = {
          domain: window.userInfo.domain,
          values: {
            'area_description': this.record.area_description,
            'creator_user': window.userInfo.email
          }
        };
        this.busy2 = true;
        UserProfileService.createArea(data).then(function (datos) {
          _this2.busy2 = false;
          if (datos.success) {
            // this.$bvModal.hide(this.modalId)
            _this2.$refs.dialog.onClose();
            tasks.toast.success('Creado correctamente');
            _this2.getRecords();
          } else {
            _this2.show_alert_and_fade();
            _this2.queryAndIndeterminate();
            tasks.toast.success(datos.message ? datos.message : 'An error occurred, please try again!');
            // this.dangerMessage = datos.message ? datos.message: "An error occurred, please try again!"
          }
        }, function (err) {
          _this2.busy2 = false;
          _this2.$refs.dialog.onClose();
          // this.$bvModal.hide(this.modalId)
        });
      } else if (this.mode == 'edit') {
        var _data = {
          domain: window.userInfo.domain,
          values: {
            'area_description': this.record.area_description,
            'creator_user': window.userInfo.email,
            'flag_active': this.record.flag_active,
            'area_id': this.record.area_id
          }
        };
        this.busy2 = true;
        UserProfileService.updateArea(_data).then(function (datos) {
          _this2.busy2 = false;
          if (datos.success) {
            _this2.$refs.dialog.onClose();
            // this.$bvModal.hide(this.modalId)
            _this2.getRecords();
          } else {
            _this2.dangerMessage = datos.message ? datos.message : 'An error occurred, please try again!';
          }
        }, function (err) {
          _this2.busy2 = false;
          _this2.$refs.dialog.onClose();
          // this.$bvModal.hide(this.modalId)
        });
      }
    },
    toggleBusy: function toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    checkFormValidity: function checkFormValidity() {
      var valid = this.$refs.form.checkValidity();
      return valid;
    },
    resetModal: function resetModal() {
      this.$bvModal.hide(this.modalId);
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.$refs['dialogConfirmation'].onOpen();
      // this.processing = false
      // this.busy = true
    },
    onCancelDelete: function onCancelDelete() {
      this.busy = false;
    },
    onConfirmDelete: function onConfirmDelete(event) {
      var _this3 = this;
      if (!event) {
        this.$refs['dialogConfirmation'].onClose();
        return;
      }
      this.processing = true;
      this.overlay_message = 'Deleting';
      console.log(this.record);
      var data = {
        domain: 'intercorp.com.pe',
        'area_id': this.record.area_id
      };
      UserProfileService.deleteAreaById(data).then(function (datos) {
        console.log(datos);
        _this3.$refs['dialogConfirmation'].onClose();
        // this.busy = this.processing = false
        tasks.toast.success('Eliminado correctamente');
        _this3.getRecords();
      }, function (err) {
        _this3.$refs['dialogConfirmation'].onClose();
        tasks.toast.success(datos.message ? datos.message : 'An error occurred, please try again!');
        // this.busy = this.processing = false
      });
    },
    rowClassFlag: function rowClassFlag(item) {
      return item && item.flag_active ? 'flag_active' : 'flag_deactive';
    },
    show_alert_and_fade: function show_alert_and_fade() {
      var _this4 = this;
      this.alert = !this.alert;
      this.resetTimer();
      var myTimer = window.setTimeout(function () {
        _this4.alert = false;
      }, 4000);
    },
    dismissible_close: function dismissible_close(value) {
      this.alert = value;
      this.resetTimer();
    },
    resetTimer: function resetTimer() {
      this.countDown.timer = 4;
    },
    queryAndIndeterminate: function queryAndIndeterminate() {
      var _this5 = this;
      this.dismissCountDown = 0;
      var interval = setInterval(function () {
        if (_this5.dismissCountDown === 100) {
          clearInterval(interval);
          _this5.dismissCountDown = 0;
        } else {
          _this5.dismissCountDown += 2.5;
        }
      }, 100);
    }
  }
};